// NOTE: need cookie.js
// TODO: Make these parameters could be built by the server
import cookieManager from "../../utils/cookie.js"
import type { Biography, Playlist, PlaylistCookies, RecordsWithUser } from "#/types"
const recordParam: string = "playlistBeginRecord"
const userParam: string = "playlistBeginUploader"

// TODO: cookie or local storage?
export const getBeginRecord = () => cookieManager.get(recordParam)
export const getBeginUser = () => cookieManager.get(userParam)
export const removePlaylistCookies = () => {
    cookieManager.remove(recordParam)
    cookieManager.remove(userParam)
}
export const setPlaylistCookies = (recordId: string, userId: string) => {
    cookieManager.set(recordParam, recordId)
    cookieManager.set(userParam, userId)
}
export class PlaylistManager implements Playlist {
    recordsWithUser: RecordsWithUser[]
    playlistType: string
    cookies: PlaylistCookies
    ownerId: Biography
    constructor(playlist: Playlist) {
        this.recordsWithUser = playlist.recordsWithUser
        this.playlistType = playlist.playlistType
        this.cookies = playlist.cookies
        this.ownerId = playlist.ownerId
    }
    getCurrentIndex(currentId: string): number {
        return this.recordsWithUser.findIndex((recordWithUser: RecordsWithUser) => recordWithUser.file.id === currentId);
    }

    private getNextIndex(currentId: string): number {
        const currIdx = this.getCurrentIndex(currentId)
        if (this.recordsWithUser.length <= 0 || currIdx >= this.recordsWithUser.length - 1) return 0
        else return currIdx + 1
    }

    private isLoop(): boolean {
        return this.playlistType != "default"
    }

    getTargetUrl(): string | null {
        let ret: string | null
        switch (this.playlistType) {
            case "like":
            case "user":
            case "high":
                ret = this.playlistType + this.ownerId.get
                break
            case "late":
            case "feat":
            case "foll":
            case "mont":
                ret = this.playlistType
                break
            default:
                ret = null
        }
        return ret
    }

    private isCookieValidate(recordId: string, userId: string): boolean { // why not checking recordId?
        return this.cookies.playlistBeginUploaderId == userId
    }

    getNextRecordWithUser(recordId: string, userId: string): RecordsWithUser | null {
        if (this.recordsWithUser.length <= 0) return null
        const nextRecord = this.recordsWithUser[this.getNextIndex(recordId)]
        if (this.isCookieValidate(recordId, userId) && (this.cookies.playlistBeginRecordId == nextRecord.file.id) && !this.isLoop()) return null
        else if (recordId != nextRecord.file.id || this.isLoop()) return nextRecord
        else return null
    }

    shouldRemoveCookie(recordId: string, userId: string): boolean {
        return !this.isCookieValidate(recordId, userId) || this.getNextRecordWithUser(recordId, userId) == null
    }
}